import { FormInstance } from 'antd';

export const selectInputFilterHelper = (
  input = '',
  option = { children: '' }
) => {
  return option.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};

export const hasFormAnyErrors = (
  form: FormInstance,
  hasAnyErrorsCallBack: (hasErrors: boolean) => void
) => {
  form.validateFields().catch((error: { errorFields?: unknown[] }) => {
    hasAnyErrorsCallBack((error.errorFields?.length ?? 0) > 0);
  });
};
